<template>
	<div>
		<b-modal
			ref="setProjectNameModal"
			@ok="editProjectName(projectId, projectName)"
			title="Edition"
			id="name"
			:cancel-title="'Annuler'"
		>
			<label for="name">{{ $t("Navbar.video_name") }}</label> <br>
			<b-form-input
				ref="focusThis"
				type="text"
				id="name"
				v-model="projectName"
			></b-form-input>
			<br>
		</b-modal>
		<keep-alive>
			<div>
				<b-modal
					:size="'lg'"
					ref="previewModal"
					:title="this.projectName"
					@hidden="stopVideo"
					:cancel-title="'Annuler'"
				>
					<div class="embed-responsive embed-responsive-16by9">
						<video
							class="embed-responsive-item video-popup"
							:src="this.videoUrl"
							ref="playerpreview"
							controls
							height="600"
							width="800"
						>
						</video>
					</div>
				</b-modal>

				<b-modal ref="modalError" hide-footer title="Erreur">
					<lottie_error />
					<p class="my-4">{{ text_error }}</p>
				</b-modal>

				<b-modal
					ref="uploadmodal"
					hide-footer
					title="Chargement..."
				>
					<throbber />
					<p class="my-4">Veuillez patienter pendant la compilation de votre vidéo. Cela peut prendre plusieurs minutes...</p>
				</b-modal>

				<Navbar :name="navbarName" />

				<div class="container mt-3">
					<b-tabs class="mt-3" id="dashboard">

						<b-tab active>
							<template #title>
								<img :src="'./static/images/projects.png'" alt="" class="tab-icon" />
								<p class="tab-title">{{ $t("Dashboard.project_list") }}</p>
							</template>

							<div class="mt-3">
								<div id="admin_controls">
<!--									<div v-if="enjoybadmin && display_admin">-->
<!--										<b-form-radio-group-->
<!--											id="btn-project-display"-->
<!--											v-model="project_display_mode"-->
<!--											:options="project_display_options"-->
<!--											buttons-->
<!--											@input="getDatas"-->
<!--										></b-form-radio-group>-->
<!--									<b-button class="delete" @click="hide_admin_menu">Masquer le menu Admin</b-button>-->
<!--									</div>-->
									<div>
										<b-form-radio-group
											id="btn-project-display"
											v-model="project_display_mode"
											:options="project_display_options"
											buttons
											@input="getDatas"
										></b-form-radio-group>
									</div>
									{{ $t("VideoLibrary.search") }}<input class="form-control no-border" type="text" v-model="filter" @input="refresh_page" />
								</div>

								<b-container class="projects-container" fluid>
									<div v-for="(project, index) in projectList_2" :key="index" class="card">
										<div v-if="!project.name">
											<router-link :to="{ name: 'ThematicSelection'}">
												<img
													class="card-img-top"
													:src=$t(project.img)
													alt="Card image cap"
													style="z-index: 0;height:275px;"
													v-bind:class="{ inactive: !project.isAvailable }"
												>
											</router-link>
										</div>
										<div
											v-else-if="project.img.includes('static')"
											:style="'background:url(' + project.img + ') center center/183px 210px no-repeat; height:210px;border-radius:10px;'"
											v-bind:class="{ inactive: !project.isAvailable }"
										>
										</div>
										<div
											v-else
											:style="'background:url(' + project.img + ') center/cover no-repeat;height:210px;border-radius:10px 10px 0 0;'"
											v-bind:class="{ inactive: !project.isAvailable }"
										>
										</div>
										<div v-if="project.name" class="card-text" v-bind:class="{ inactive: !project.isAvailable }">
											{{ project.name }}
										</div>
										<div class="card-date" v-if="project.created_at">
											{{ project.created_at }}
										</div>
										<div class="card-username" v-if="project.username">
											{{ project.username }}
										</div>
										<div class="card-thematic" v-if="project.thematicId">
											{{ $t(project.thematicId) }}
										</div>
										<div class="card-category" v-if="project.category">
											{{ project.category }}
										</div>
										<div
											class="card-body"
											v-if="project.name"
											v-bind:class="{ inactive: !project.isAvailable }"
										>
											<div class="button-list">
												<div>
													<a
														href="#"
														v-bind:class="{ disable: !project.isAvailable }"
														@click.prevent="deleteProject(project)"
													> <img
														:src="'./static/images/projectactiondelete.png'"
														alt="Delete"
													/></a>
												</div>
												<div>
													<a
														href="#"
														v-bind:class="{ disable: !project.isAvailable }"
														@click.prevent="(project.video_absolute_url === null) ? previewProject(project) : previewVideoProject(project.video_absolute_url)"
													> <img
														:src="'./static/images/projectactionpreview.png'"
														alt="Preview"
													/> </a>
												</div>
												<div>
													<a
														href="#"
														v-bind:class="{ disable: !project.isAvailable }"
														@click.prevent="openModal(project.id, project.name)"
													> <img
														:src="'./static/images/projectactioneditname.png'"
														alt="Edition du nom du projet"
													/> </a>
												</div>
												<div>
													<router-link
														:to="{ name: 'ProjectEdition', params: { id: project.id }}"
														v-bind:class="{ disable: !project.isAvailable }"
													>
														<img
															:src="'./static/images/projectactionedit.png'"
															alt="Edit"
														/>
													</router-link>
												</div>
											</div>
										</div>
									</div>
								</b-container>

								<b-pagination
									v-model="current_page"
									:total-rows="total_projects"
									:per-page="per_page"
									align="center"
								></b-pagination>

							</div>
						</b-tab>

						<b-tab v-if="false">
							<template #title>
								<img :src="'./static/images/imageright.png'" alt="" class="tab-icon" />

								<p class="tab-title">{{ $t("Dashboard.labelImageRights") }}</p>
							</template>
							<ImageRightsRecords />
						</b-tab>

						<b-tab v-if="this.admin">
							<template #title>
								<img :src="'./static/images/administration.png'" alt="" class="tab-icon" />
								<p class="tab-title">{{ $t("VideoLibrary.tab_title") }}</p>
							</template>
							<VideothequeAdmin />
						</b-tab>

						<b-tab v-if="this.admin">
							<template #title>
								<img :src="'./static/images/statistics.png'" alt="" class="tab-icon" />
								<p class="tab-title">{{ $t("Statistics.tab_title") }}</p>
							</template>
							<StatisticsAdmin />
						</b-tab>

						<b-tab v-if="this.enjoybadmin">
							<template #title>
								<img :src="'./static/images/adduser.png'" alt="" class="tab-icon" />
								<p class="tab-title">{{ $t("Gestion utilisateurs") }}</p>
							</template>
							<UserAdmin />
						</b-tab>

					</b-tabs>
				</div>
			</div>
		</keep-alive>
		<div id="version_num">{{ version_number }}</div>
	</div>
</template>

<script>
import Navbar from "../ui/Navbar";
import VideoLibrary from "../ui/VideoLibrary";
import VideothequeAdmin from "../views/Admin";
import StatisticsAdmin from "../views/Stats";
import UserAdmin from "../views/Adduser";
import throbber from "@/components/ui/throbber";
import lottie_error from "@/components/ui/lottie_error";
import axios from "axios";
import {EventBus} from "../../event/event-bus";
import ImageRightsRecords from "../views/ImageRightsRecords";
import ImageRightsAgreement from "../views/ImageRightsAgreement";

const chunk = (arr, size) =>
	Array.from({length: Math.ceil(arr.length / size)}, (v, i) =>
		arr.slice(i * size, i * size + size),
	);

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "Dashboard",
	components: {
		VideoLibrary,
		Navbar,
		VideothequeAdmin,
		StatisticsAdmin,
		UserAdmin,
		throbber,
		lottie_error,
		ImageRightsRecords,
		ImageRightsAgreement,
	},
	data() {
		return {
			version_number: "0.12.20",
			admin: false,
			enjoybadmin: false,
			thumbnails: {},
			projects: [],
			show: true,
			videoUrl: "",
			text_error: "",
			projectName: "",
			oldProjectName: "",
			projectId: "",
			filter: "",

			global_interval: null,
			update_date: null,

			per_page: 10,
			current_page: 1,

			project_display_mode: "mine",
			project_display_options: [
				{text: "Mes projets", value: "mine"},
				{text: "Tous les projets", value: "all"},
			],
			display_admin: true,
		};
	},
	computed: {
		navbarName() {
			return this.$root.$t("Dashboard.name");
		},
		projectList_2() {
			let selection = this.projects.filter(this.filterData);
			let page = selection.slice((this.current_page - 1) * this.per_page, this.current_page * this.per_page);
			return page;
		},
		total_projects() {
			return this.projects.filter(this.filterData).length;
		},
	},
	created() {
		let $this = this;
		EventBus.$on("setLanguage", lang => {
			$this.$root.$i18n.locale = lang;
		});
		this.admin = sessionStorage.getItem("usermail") === "kevin.lemoine@enjoyb.fr"
			|| sessionStorage.getItem("usermail").includes("@enjoyb.fr");
		this.enjoybadmin = sessionStorage.getItem("usermail").includes("enjoyb.fr");

		for (let item of process.env.VUE_APP_THEMATICS) {
			$this.thumbnails[item.name] = item.thumb;
		}

		this.getDatas();

		if (window.global_interval !== null) {
			clearInterval(window.global_interval);
		}

		window.global_interval = setInterval(function () {
			$this.auto_refresh();
		}, 10000);
	},
	methods: {
		getDatas() {
			let $this = this;
			let datas = [];
			// datas.push({img: "./static/images/new.png", isAvailable: 1});
			datas.push({img: "new_project_image", isAvailable: 1});

			axios.get(BASE_URL + "/public/api/projects?mode=" + this.project_display_mode, {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			})
			.then(function (response) {
				let data = response.data.data.projects;
				if (data !== undefined) {
					data.forEach(function (item) {
						let projectThumbnail = "";
						let dest = JSON.stringify(item.destinationLang);
						if (item.thumbnail === null) {
							projectThumbnail = $this.thumbnails[item.thematicId] || "";
						}
						else {
							projectThumbnail = item.thumbnail;
						}
						datas.push({
							created_at: new Date(item.updated_at.date).toLocaleString("fr-FR", {timeZone: item.updated_at.timezone}),
							name: item.name,
							isAvailable: item.isAvailable,
							thematicId: item.thematicId,
							id: item.id,
							username: item.user.name,
							video_relative_url: item.video_relative_url,
							video_absolute_url: item.video_absolute_url,
							sourceLang: item.sourceLang,
							dest_lang: dest,
							img: projectThumbnail,
							category: item.category,
						});
					});
				}
				$this.projects = datas;
				// $this.update_date = null;
			})
			.catch(error => {
				this.text_error = this.$root.$t("Errors.message_general") + error;
				this.$refs.modalError.show();
			});
		},
		filterData(project) {
			let filters = this.filter.toLowerCase().split(" ");
			// let locale = this.$root.$t("date_locale");

			let result = true;

			for (let filter of filters) {
				if (result) {
					if ("username" in project) {
						result = project.username.toLowerCase().includes(filter)
							// || project.email.toLowerCase().includes(filter)
							|| project.name.toLowerCase().includes(filter)
							|| project.thematicId.toLowerCase().includes(filter)
							|| project.category.toLowerCase().includes(this.filter)
							|| project.id.toString().includes(this.filter);
						// 		// project.date_sorting.includes(this.filter) ||
						// 		// project.date_obj.toLocaleDateString(locale).includes(this.filter);
					}
				}
			}
			return result;
		},
		openModal(id, name) {
			this.projectName = name;
			this.oldProjectName = name;
			this.projectId = id;
			this.$refs.setProjectNameModal.show();
			if (this.$refs.setProjectNameModal.false) {
				this.projectName = this.$route.query.n;
			}
			this.$refs.focusThis.focus();
		},
		editProjectName(id, value) {
			let $this = this;
			let bodyFormData = new FormData();
			bodyFormData.append("name", value);
			bodyFormData.append("_method", "PUT");

			axios.post(BASE_URL + "/public/api/projects/" + id,
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function (response) {
				$this.projectName = "";
				$this.oldProjectName = "";
				$this.getDatas();
			}).catch(error => {
				this.text_error = this.$root.$t("Errors.message_general") + error;
				this.$refs.modalError.show();
			});
		},
		previewProject(project) {
			let arrayStep = [];
			let $this = this;
			if (project.isAvailable !== 0) {
				axios.get(BASE_URL + "/public/api/projects/" + project.id + "/visiblesSteps", {
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				})
				.then(function (response) {
					let data = response.data.project.data.steps;
					data.forEach(function (items, index, value) {
						arrayStep.push(items);
					});
					let finalArray = arrayStep.filter(step => (step.isCompleted === true));
					if (finalArray.length === 0) {
						$this.text_error = "Vous ne pouvez pas compiler un projet vide. Veuillez compléter au moins une étape vidéo.";
						$this.$refs.modalError.show();
					}
					else {
						$this.projectName = project.name;
						$this.$refs.uploadmodal.show();
						$this.compilProject(project.id, finalArray);
					}
				})
				.catch(error => {
					$this.text_error = "L'erreur suivante est survenue. Merci de nous contacter, " +
						"et veuillez nous excuser pour la gêne occasionnée. Code de l'erreur : " + error;
					$this.$refs.modalError.show();
				});
			}
		},
		compilProject(id, data) {
			let $this = this;
			axios.post(BASE_URL + "/public/api/projects/" + id + "/compil", {
				data: data,
				id: id,
			}, {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			}).then(function (response) {
				$this.videoUrl = response.data.video_absolute_url + "#" + new Date().getTime();
				$this.$refs.uploadmodal.hide();
				$this.$refs.previewModal.show();
			}).catch(error => {
				this.$refs.uploadmodal.hide();
				this.text_error = this.$root.$t("Errors.message_general") + error;
				this.$refs.modalError.show();
			});
		},
		stopVideo() {
			if (this.$refs.playerpreview.played) {
				this.$refs.playerpreview.pause();
			}
		},
		previewVideoProject(videoUrl) {
			this.videoUrl = videoUrl + "#" + new Date().getTime();
			this.$refs.previewModal.show();
		},
		refresh_page() {
			// console.log(this.current_page);
			this.current_page = 1;
		},
		auto_refresh() {
			let $this = this;
			if (this._isDestroyed) {
				clearInterval(window.global_interval);
			}
			else {
				axios.get(BASE_URL + "/public/api/projects_u", {
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				}).then(function (response) {
					let new_date = response.data.date;
					if ($this.update_date == null) {
						$this.update_date = new_date;
					}
					else {
						if ($this.update_date !== new_date) {
							$this.getDatas();
							$this.update_date = new_date;
						}
					}
				});
			}
		},
		deleteProject(project) {
			if (confirm("En cliquant sur OK, vous supprimerez définitivement votre projet. Continuer ?")) {
				let $this = this;
				if (project.isAvailable !== 0) {
					axios
					.delete(BASE_URL + "/public/api/projects/" + project.id,
						{
							headers: {
								"Authorization": sessionStorage.getItem("auth"),
							},
						})
					.then(function () {
						// $this.projectList.splice($this.getDatas());
						$this.getDatas();
					})
					.catch(error => {
						$this.text_error = "L'erreur suivante est survenue. Merci de nous contacter, " +
							"et veuillez nous excuser pour la gêne occasionnée." + error;
						$this.$refs.modalError.show();
					});
				}
			}
		},
		compare(a, b) {
			if (a.file_lang > b.file_lang) {
				return -1;
			}
			if (a.file_lang < b.file_lang) {
				return 1;
			}
			return 0;
		},
		hide_admin_menu() {
			this.project_display_mode = "mine";
			this.display_admin = false;
			this.getDatas()
		}
	},
};

</script>

<style scoped>

#admin_controls {
	margin: 24px 12px;
}

#admin_controls input {
	width: 300px;
	border: 1px solid var(--color-border-inputs);
}

#admin_controls .delete {
	background-color: var(--color-cancel);
	border-color: var(--color-cancel);
	color: var(--text-cancel);
	float: right;
}

.form-control.no-border {
	border-top: 0;
	border-left: 0;
	border-right: 0;
	border-bottom: solid 1px;
}

.inactive {
	opacity: .4;
}

.tab-icon {
	display: block;
	width: 44px;
	height: 44px;
}

.tab-title {
	margin: 7px 0 0;
}

.nonAvailable {
	text-align: center;
	z-index: 1;
	top: 40%;
	color: darkred;
	position: absolute;
	line-height: 15px;
	font-weight: bold;
	font-size: 22px;
	left: 10%;
	width: 80%;
}

.disable {
	cursor: default;
	pointer-events: none;
}

.projects-container {
	display: flex;
	flex-wrap: wrap;
	gap: 25px;
	justify-content: flex-start;
	margin-bottom: 25px;
}

@media screen and (max-width: 1200px) {
	.projects-container {

	}
}

/*#flash{*/
/*animation: Flash 5s infinite;*/
/*}*/
/*@keyframes Flash{*/
/*0%{opacity: 1;}*/
/*50%{opacity: 0;}*/
/*100%{opacity: 1;}*/
/*}*/
.card {
	flex-basis: 183px;
	border-radius: 10px;
	border: 0;
	position: relative;
	padding-left: 0;
	padding-right: 0;
	background-color: var(--color-background);
	transition: box-shadow .2s linear;
}

.card:hover {
	box-shadow: 0 0 15px #00000080;
}

.card-text {
	text-align: center;
	z-index: 1;
	bottom: 39.5%;
	color: var(--color-text-title);
	position: absolute;
	font-weight: bold;
	text-transform: uppercase;
	font-size: 12px;
	width: 160px;
	background-color: var(--color-background-title);
	border-radius: 5px;
	left: 50%;
	transform: translateX(-50%);
	padding: 3px 10px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.card-date {
	margin-top: .5rem;
	position: absolute;
	text-align: center;
	font-size: 12px;
	font-weight: 700;
	top: 2%;
	width: 80%;
	display: table;
	left: 10%;
	color: white;
	text-shadow: 0 0 10px #000000, 0 0 10px #000000;
}

.card-username {
	text-align: center;
	z-index: 1;
	top: 68%;
	color: white;
	position: absolute;
	line-height: 15px;
	font-weight: bold;
	font-size: 10px;
	left: 10%;
	width: 80%;
	text-shadow: 0 0 10px #000000, 0 0 10px #000000;
}

.card-category {
	text-align: center;
	z-index: 1;
	top: 12%;
	color: white;
	position: absolute;
	line-height: 15px;
	font-weight: bold;
	font-size: 15px;
	left: 10%;
	width: 80%;
	text-shadow: 0 0 10px #000000, 0 0 10px #000000;
}

.card-thematic {
	text-align: center;
	z-index: 1;
	top: 63%;
	color: white;
	position: absolute;
	line-height: 15px;
	font-weight: bold;
	font-size: 10px;
	left: 10%;
	width: 80%;
	text-shadow: 0 0 10px #000000, 0 0 10px #000000;
}

.card-body {
	background-color: var(--color-background);
	border-radius: 0 0 10px 10px;
	padding: 0;
	height: 65px;
}

.card-body .button-list {
	display: flex;
	justify-content: space-evenly;
	margin-top: 12px;
}

.card-body a {
	display: block;
	margin: 0 auto;
	padding: 4px;
}

.card-body a:hover {
	border-bottom: 2px solid var(--color-border-link);
	/*border-radius: var(--border-radius);*/
}

.card-body a img {
	display: block;
	width: 30px;
	height: 30px;
}

.card .card-img-top {
	width: 100%;
}

.card_new_project .card-img-top {
	height: 100%;
	width: 120%;
	margin: 0;
}

.video-popup {
	background: #2C2A29;
}

#version_num {
	font-family: monospace;
	position: fixed;
	right: 10px;
	bottom: 0;
	color: transparent;
	transition: color 3s;
	cursor: pointer;
}

#version_num:hover {
	color: #000000;
}

</style>
